<template>
    <div>
        <b-form @submit.prevent="saveCategory()" data-vv-scope="formCategorie">
            <b-row>

                <b-col cols="12">
                    <b-form-group>
                        <label>Tipo de peligro <span class="text-danger">*</span></label>
                        <el-select v-model="category.sga_type_of_danger_id" clearable filterable size="medium"
                            placeholder="Seleccionar tipo de peligro" name="tipo_peligro" v-validate="'required'"
                            data-vv-as=" ">
                            <el-option v-for="item in getActiveTypesOfDangers" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                        <span class="text-danger small" v-text="errors.first('formCategorie.tipo_peligro')" />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-textarea v-model="category.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " rows="6" />
                        <span class="text-danger small" v-text="errors.first('formCategorie.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="hasValidLanguages">
                    <b-list-group>
                        <b-list-group-item v-for="language in category.sga_category_languages" :key="language.id"
                            v-if="language.sga_language.code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    <span class="fw-bold">
                                        <input v-model="language.value" type="text"
                                            class="form-control form-control-sm w-100" />
                                    </span>
                                </div>
                                <div class="ms-auto ml-2">
                                    <b-badge variant="primary">{{ language.sga_language.code }}</b-badge>
                                    <span class="text-muted"> - {{ language.sga_language.name }}</span>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelCategory">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormCategories',

    computed: {
        ...mapState('sgaCategories', ['action', 'category']),
        ...mapState('sgaTypesOfDangers', ['activeTypesOfDangers']),
        ...mapState('sgaVersions', ['activeVersions', 'activeGlobalVersion']),

        hasValidLanguages() {
            return Array.isArray(this.category.sga_category_languages) &&
                this.category.sga_category_languages.length > 0;
        },

        getActiveTypesOfDangers() {
            return this.activeTypesOfDangers.filter(x => x.version.id == this.activeGlobalVersion)
        }

    },

    created() {
        this.getActiveTypesOfDangerSga();
    },

    methods: {
        ...mapActions('sgaCategories', ['createCategorySga', 'getCategoriesSga', 'updateCategorySga']),
        ...mapActions('sgaTypesOfDangers', ['getActiveTypesOfDangerSga']),
        ...mapActions('sgaVersions', ['getActiveVersionsSga']),

        ...mapMutations('sgaCategories', ['setDefaultCategorySga']),
        ...mapMutations('sgaVersions', ['setActiveGlobalVersion']),

        cancelCategory() {
            this.setDefaultCategorySga();
            this.$bvModal.hide('modal_create_categories');
        },

        async cancelAndGetCategories() {
            this.cancelCategory();
            await this.getCategoriesSga();
        },

        async saveCategory() {
            const isValid = await this.$validator.validateAll('formCategorie');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateCategorySga(this.category);
            } else {
                flag = await this.createCategorySga(this.category);
            }

            if (flag) {
                this.cancelAndGetCategories();
            }
        },

        onHandleChangeVersion(edition) {
            this.setActiveGlobalVersion(edition)
        }
            
    }
}
</script>
